import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services'
import { DatePicker } from '@progress/kendo-react-dateinputs';
var localizedData = [];
const dateFormat = "dd-MM-yyyy";
class DatePickerGrid extends Component {


  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];
    if(dataValue != null && dataValue != ""){
      var data = new Date(dataValue);
        var dia = data.getDate() < 10 ? "0"+data.getDate() : data.getDate();
        var mes = data.getMonth()+1 < 10 ? "0"+data.getMonth() : data.getMonth();
        var ano = data.getFullYear()
    }
   
    return (
        <td>
            {dataItem.inEdit ?
            <DatePicker
                className="form-control"
                size="small"
                disabledDate={this.disabledDate}
                //value={moment(date, dateFormat)}
                format={dateFormat}
                onChange={this.handleChange}
                id = 'DatePickerPenhora'
            />
           
            : dataValue != null && dataValue != "" ? dia + "/" + mes + "/" + ano : undefined}
        </td>
    );
  }
    
}

export default DatePickerGrid;